import {Component, Input, OnInit, OnChanges} from '@angular/core';
import { ReservasService } from '@app/services/reservas.service';
import { Field } from '@app/_models/facilities';

@Component({
  selector: 'app-reservas-cancha',
  templateUrl: './reservas-cancha.component.html',
  styleUrls: ['./reservas-cancha.component.scss'],
})
export class ReservasCanchaComponent implements OnInit, OnChanges {
  @Input() cancha: Field;
  @Input() day_array;
  @Input() day;
  reservas: any;
  closedShifts: string[];
  initializing: Boolean = true;
  init_reservas = true;
  init_closedshifts = true;

  constructor(private reservasService: ReservasService) {}

  ngOnInit() {
    this.getData();
  }

  ngOnChanges() {
    this.getData();
  }

  getData() {
    this.initializing = true;
    this.getReservas(this.day);
    this.getClosedShifts(this.day);
  }

  getReservas(day) {
    this.reservasService.getReservas(this.cancha.id, day).subscribe(
      data => {
        this.reservas = data;
        this.init_reservas = false;
        this.initializing = this.init_reservas || this.init_closedshifts;
      },
      error => console.log('error: ', error)
    );
  }

  getClosedShifts(day) {
    this.closedShifts = [];
    this.reservasService
      .getClosedShifts(this.cancha.id, day)
      .subscribe(data => {
        this.handleData(data);
      });
  }


  calcularDiferenciaHoras(startDate: Date, endDate: Date): number[] {
    const sDate = new Date(startDate);
    const eDate = new Date(endDate);

    const diffMilliseconds = eDate.getTime() - sDate.getTime();
    const diffHours = diffMilliseconds / (1000 * 60 * 60);
  
    const horasArray: number[] = [];
    for (let i = 0; i < diffHours; i++) {
      horasArray.push(i + startDate.getHours());
    }
  
    return horasArray
  }


  handleData(data) {
    for (let item of data) {
      var cs = this.cancha.id + '-' + item.date_and_time.substr(11, 5);
      this.closedShifts.push(cs);
    }

    this.init_closedshifts = false;
    this.initializing = this.init_reservas || this.init_closedshifts;
  }

  onReservaModified(value) {
    if (value) {
      this.getData();
    }
  }

  isTimeUnavailable(time: string): boolean {
    const selectDay = new Date(this.day.toString());
    const weekDay = selectDay.getDay();
    const openHour = weekDay === 0 || weekDay === 6 ? 9 : 17;
    const hours = Number(time.split(":")[0]);
    return hours < openHour;
  }
}
